import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject, input, signal } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FileTemplatesService } from '../../../core-module/services/file-templates.service';
import { RoleBaseComponent } from '../../../shared-module/components/role-base.component';

@Component({
  selector: 'app-second-nav-menu',
  imports: [
    CommonModule,
    RouterModule,
    MatTooltipModule
  ],
  templateUrl: './second-nav-menu.component.html',
  styleUrl: './second-nav-menu.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecondNavMenuComponent extends RoleBaseComponent {

  private fileTemplatesService = inject(FileTemplatesService);
  private elementRef = inject(ElementRef);

  menuItems = input<any[]>([]);
  showJasperMenu = signal(false);

  @HostListener('document:click', ['$event'])
  onClickout(event: Event) {
    if (this.elementRef.nativeElement.contains(event.target)) {
      // inside, do nothing.
    } else {
      this.showJasperMenu.set(false);
    }
  }

  onHelpDesk() {
    this.fileTemplatesService.getChatBotFileUrl()
      .subscribe(rs => {
        let body = <HTMLDivElement>document.body;
        let script = document.createElement('script');
        script.innerHTML = '';
        script.src = rs.result;
        script.async = true;
        script.defer = true;
        body.appendChild(script);
        setTimeout(() => {
          console.log(document.getElementById('Botsonic-wrapper'))
          console.log(document.getElementById('widget-Botsonic'))
          document.getElementById('Botsonic-wrapper')?.click();
          document.getElementById('widget-Botsonic')?.click();
        }, 5000);
      });
  }

  onJasperClick() {
    this.showJasperMenu.update(current => !current);
  }

  onJasperItemClick(mi: any) {
    this.showJasperMenu.set(false);
  }

  private getJasperMenuItems() {
    return [
      {
        name: 'HELPDESK',
        navCommands: ['/help-desk'],
        description: 'Your trusted guide for quick support and seamless solutions-always here to help when you need it most.'
      },
      {
        name: 'PROCESSOR APPROVAL',
        navCommands: ['/cal/ai'],
        description: 'Ensuring every detail is aligned for fast, accurate approvals-powering up your processing workflow with confidence.'
      },
      {
        name: 'INCOME CALCULATION',
        navCommands: [],
        //description: 'Precise income insights at your fingertips-streamlining calculations to simplify your client\'s path to homeownership.'
        description: 'COMING SOON...'
      }
    ];
  }

  

}
